import { Skeleton } from "@/atoms"
import { DotChartOutlined } from "@/icons"

import styles from "./LoaderWidget.module.scss"

export const LoaderWidget = () => (
  <Skeleton.Node
    active
    classNames={{ root: styles.root, content: styles.container }}
  >
    <DotChartOutlined className={styles.icon} />
  </Skeleton.Node>
)
